import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import {
  Typography, Button, Grid,
} from '@material-ui/core';

import KpiSection from './KpiSection/KpiSection';
import BarDonutSection from './BarDonutSection/BarDonutSection';
import WaffleSection from './WaffleSection/WaffleSection';
import BubbleSection from './BubbleSection/BubbleSection';
import SwarmSection from './SwarmSection/SwarmSection';
import PieSection from './PieSection/PieSection';
import MapSection from './MapSection/MapSection';

import TranslationTxt from './TranslationTxt/TranslationTxt';
import languagify from '../../utils/languagify';

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  intro: {
    fontSize: '1.125em',
  },
  introText: {
    maxWidth: 700,
  },
  cta: {
    backgroundColor: '#BE7999',
    padding: '10px 15px',
    borderRadius: 3,
    width: '100%',
    maxWidth: 270,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#955e78',
    },
  },
  ctaText: {
    display: 'block',
    fontSize: '0.7em',
    paddingTop: 10,
    maxWidth: 270,
  },
  gridItmBubble: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  gridItmTopJournalists: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
    '@media (min-width: 1100px)': {
      paddingLeft: '102px !important',
    },
  },
  footnotecontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 50,
    '@media(max-width: 684px)': {
      justifyContent: 'center',
    },
  },
  footnote: {
    position: 'absolute',
    color: '#5C5C5C',
    fontStyle: 'italic',
    fontSize: 12,
    '@media(max-width: 684px)': {
      position: 'relative',
      textAlign: 'center',
    },
  },
}));

const Survey2022 = () => {
  const classes = useStyles();

  return (
    <div>
      <Container maxWidth="lg">

        <Grid container spacing={4} className={classes.intro}>
          <Grid item xs={12} sm={8}>
            <Typography variant="body1" className={classes.introText}>
              {/* <TranslationTxt measure="=Only({<Index = {2}>}[$(vLanguage)])" /> */}
              {languagify('The Canadian Association of Journalists’ second annual diversity survey includes data from 5,012 journalists working in 242 newsrooms nationwide. It is Canada’s largest survey of the race and gender of those who work in media. Data analysis and interactives were produced by Pennsylvania-based firm Qlik.')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <Button variant="contained" color="primary" className={classes.cta} target="_blank" href={languagify('https://caj.ca/wp-content/uploads/Canadian-Newsroom-Diversity-Survey-2022.pdf')}>
                <TranslationTxt measure="=Only({<Index = {3}>}[$(vLanguage)])" />
              </Button>
              <Typography variant="body1" className={classes.ctaText}>
                <TranslationTxt measure="=Only({<Index = {4}>}[$(vLanguage)])" />
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box className={classes.contentWrapper}>
          <KpiSection
            header="=Only({<Index = {5}>}[$(vLanguage)])"
            text="=Only({<Index = {6}>}[$(vLanguage)])"
          />
          <WaffleSection />
          <SwarmSection
            header="=Only({<Index = {35}>}[$(vLanguage)])"
            text="=Only({<Index = {36}>}[$(vLanguage)])"
          />
          <Grid container spacing={9}>
            <Grid item sm={12} md={6} className={classes.gridItmBubble}>
              <BubbleSection
                header="=Only({<Index = {44}>}[$(vLanguage)])"
                text="=Only({<Index = {45}>}[$(vLanguage)])"
              />
            </Grid>
            <Grid item sm={12} md={6} className={classes.gridItmTopJournalists}>
              <PieSection
                header="=Only({<Index = {49}>}[$(vLanguage)])"
                text="=Only({<Index = {52}>}[$(vLanguage)])"
              />
            </Grid>
          </Grid>

          <BarDonutSection
            header="=Only({<Index = {60}>}[$(vLanguage)])"
            text="=Only({<Index = {61}>}[$(vLanguage)])"
          />

          <Box className={classes.map}>
            <MapSection
              header="=Only({<Index = {68}>}[$(vLanguage)])"
              text="=Only({<Index = {69}>}[$(vLanguage)])"
            />
          </Box>

        </Box>
      </Container>
      <Container maxWidth="lg">
        <div className={classes.footnotecontainer}>
          <Typography variant="body1" className={classes.footnote}><TranslationTxt measure="=Only({<Index = {62}>}[$(vLanguage)])" /></Typography>
        </div>
      </Container>
    </div>
  );
};

Survey2022.propTypes = {};

export default Survey2022;
